export const getUpdateState =
  <T>(state: T) =>
  (changes: Partial<T>) => ({ ...state, ...changes });
